/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreHistoryManagementExportOrderResponse } from './StoreHistoryManagementExportOrderResponse';

export type StoreHistoryManagementExportOrderResponseApiRespoonse = {
    data?: StoreHistoryManagementExportOrderResponse;
    status?: StoreHistoryManagementExportOrderResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreHistoryManagementExportOrderResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

